'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _ICON_SETS;

export var ICON_SETS = (_ICON_SETS = {}, _defineProperty(_ICON_SETS, 'fontawesome-5', 'fontawesome-5'), _defineProperty(_ICON_SETS, 'fontawesome-5.0.10', 'fontawesome-5.0.10'), _defineProperty(_ICON_SETS, 'fontawesome-5.14.0', 'fontawesome-5.14.0'), _ICON_SETS);
export var DEFAULT_ICON_SET = ICON_SETS['fontawesome-5.0.10'];